module.exports = __webpack_public_path__ + "static/media/stop-15.7c25a969.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-15.svg
// module id = 1360
// module chunks = 0